import React from 'react'
import {Form } from 'semantic-ui-react'
import GridSearchTemplate from '../../../pages/GridSearchTemplate';
import { DatePicker } from '../../shared/DatePicker';
import HotelsDropDown from '../../shared/HotelsDropDown';
import { useTextResources } from '../../../language';
import { GetBankDetailsReport } from '../../../api/services/finance';

const BankDepositReport = ()=>{
    const text = useTextResources()
    const gridOptions = {
        search: {
            title: "Bank Deposit Report",
            description: "Some description",
            fields: [ 
                <Form.Field multiple clearable control={HotelsDropDown} label="Hotel" key="HotelIDs"/>,
                <DatePicker 
                    type="basic"
                    label= {text("StartDate")} 
                    name="StartDate"
                    key="StartDate"
                />,
                <DatePicker 
                    type="basic"
                    label= {text("EndDate")}
                    name="EndDate"
                    key="EndDate"
                />
            ],
            api: GetBankDetailsReport
        },
        grid: {
            menu: {
                left: [],
                right: []
            },
            columns: [
                { name: 'BusinessDate', title: 'Date' },
                { name: 'AmountBeforeTax', title: 'Amount' },
                { name: 'ReservationNumber', title: 'Reservation Number' },
                { name: 'HotelName', title: 'Hotel' }
            ]
        }
    }
    return (<GridSearchTemplate options={gridOptions}/>)
}
export default BankDepositReport